import React, { memo } from 'react';
import { OnboardingCell } from './stages/OnboardingCell';


const OnboardingViewRow = memo(({ onboardingId }) => {

  if (!onboardingId) {
    console.log("Row Onboarding ID not found: ", onboardingId);
    return <tr><td colSpan="100%">Loading...</td></tr>;
  }
  console.log("Row Onboarding ID found: ", onboardingId);


  return (
    <tr className="table-row">
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="overview" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="signedDate" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="kickoff" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="isLinkedToPractice" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="registrationComplete" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="portRequest" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="phones" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="trainingKb" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="trainingWorkflow" 
      />
      <OnboardingCell 
        onboardingId={onboardingId} 
        stage="goLive" 
      />

      
    </tr>
  );
});

OnboardingViewRow.displayName = 'OnboardingViewRow';

export default OnboardingViewRow;
